export default "__VITE_ASSET__371aeaef__"